const configClient = {
  title: 'Bora Tickets',
  subtitle: '',
  description: '',
};

export default configClient;
